// Carriers list URL state — FE-SCRM-030.
//
// Filters live in the URL query string so deep links share state
// and back-button navigation restores the user's view. Pattern
// matches AccountListPage's urlState.ts so the FE stays consistent.

import {
  CARRIER_STATUSES,
  CARRIER_TYPES,
  type CarrierListFilters,
  type CarrierStatus,
  type CarrierType,
} from "./types";


// Default status is ``active`` per the spec — users open Carriers to
// see the working set, not deactivated rows. Setting an explicit
// ``status=active`` in the URL would be noisy on first load, so the
// page treats "no status param" as the active default. ``all`` and
// ``inactive`` round-trip through the URL.
export function parseFiltersFromSearch(
  search: URLSearchParams,
): CarrierListFilters {
  const filters: CarrierListFilters = {};
  const q = (search.get("q") ?? "").trim();
  if (q) filters.q = q;
  const ct = search.get("carrier_type");
  if (ct && (CARRIER_TYPES as readonly string[]).includes(ct)) {
    filters.carrier_type = ct as CarrierType;
  }
  const status = search.get("status");
  if (status === "all") {
    filters.status = "all";
  } else if (
    status && (CARRIER_STATUSES as readonly string[]).includes(status)
  ) {
    filters.status = status as CarrierStatus;
  } else {
    filters.status = "active";
  }
  return filters;
}


export function serializeCarriersListUrl(filters: CarrierListFilters): string {
  const sp = new URLSearchParams();
  if (filters.q) sp.set("q", filters.q);
  if (filters.carrier_type) sp.set("carrier_type", filters.carrier_type);
  // Omit the default ``status=active`` to keep the URL clean.
  if (filters.status && filters.status !== "active") {
    sp.set("status", filters.status);
  }
  const qs = sp.toString();
  return qs ? `/dashboard/carriers?${qs}` : "/dashboard/carriers";
}
